export default __webpack_public_path__ + "static/media/photo--sm--group-nice.2ea2b40c.jpg";